// Coy mega-menu: hovering OR keyboard-focusing a department in the left rail swaps the right panel.
// `focusin` matters: inactive panels are display:none, so without it a keyboard user tabbing the
// rail can only ever reach the links inside panel 0 — every other department is unreachable.
(function () {
  function activate(item) {
    var mega = item.closest('[data-coy-mega]');
    if (!mega) return;
    var idx = item.getAttribute('data-coy-rail');
    mega.querySelectorAll('[data-coy-rail]').forEach(function (r) {
      r.classList.toggle('is-active', r === item);
    });
    mega.querySelectorAll('[data-coy-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-coy-panel') === idx);
    });
  }
  function onEvent(e) {
    var item = e.target.closest && e.target.closest('[data-coy-rail]');
    if (item) activate(item);
  }
  document.addEventListener('pointerover', onEvent);
  document.addEventListener('focusin', onEvent);
})();
